import { defineComponent as o, createBlock as n, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconCharter",
  __name: "IconCharter",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (d, e) => (a(), n(l(i), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M4.25 18.5v-13A2.25 2.25 0 0 1 6.5 3.25h12a1.25 1.25 0 0 1 1.25 1.25V17A.75.75 0 0 1 19 17.75H6.5a.75.75 0 0 0 0 1.5H19a.75.75 0 0 1 0 1.5H6.5a2.25 2.25 0 0 1-2.25-2.25m1.5-13A.75.75 0 0 1 6.5 4.75H12v5.767a.2.2 0 0 0 .341.142L13.86 9.14a.2.2 0 0 1 .282 0l1.518 1.518A.2.2 0 0 0 16 10.517V4.75h2.25v11.5H6.5a2.247 2.247 0 0 0-.75.128V5.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
